import { constantStrings } from "../services/constants"

export default {
  getColor (state) {
    return state?.widgetConfig?.theme?.current === 'dark' ? '#FFFFFF' : '#000000'
  },
  getTextColor (state) {
    const textColor = state.widgetConfig.textColor || '#ffffff'
    const themeColor = state?.widgetConfig?.theme?.current === 'dark' ? '#FFFFFF' : '#000000'
    return textColor?.toLowerCase() === '#ffffff' ? themeColor : textColor
  },
  isGradientEnabled (state) {
    return state?.widgetConfig?.theme?.gradient
  },
  getPendingForm(state) {
    const chats = state.chats.slice(-1)[0]
    if (!chats) return []
    return (
      (chats.messages &&
        chats.messages.filter(message => {
          return (
            message.type === 'HumanHandoffForm' &&
            message.messageValue?.values?.['status']?.[0] === 'PENDING'
          )
        })) ||
      []
    )
  },

  getLastUserMessage(state) {
    const chats = state.chats
    const len = chats.length
    for (let i = len - 1; i >= 0; i--) {
      if (chats[i].isUser) {
        return chats[i]
      }
    }
    return null
  },

  getLastMessageTimestamp(state) {
    const chats = state.chats
    const len = chats.length
    for (let i = len - 1; i >= 0; i--) {
      if (chats[i].timestamp) {
        return chats[i].timestamp
      }
    }
    return null
  },

  getBotRefId (state) {
    return state.botRefId
  },

  getWidgetId (state) {
    return state.widgetId
  },

  getUserId (state) {
    return state.user.id
  },

  getEmailId (state) {
    return state.user.email
  },

  isSoundEnable (state) {
    return state?.widgetConfig?.sound && state.widgetConfig.sound.status === "enabled"
  },

  isSoundOnByDefault (state, getters) {
    return getters.isSoundEnable && state.widgetConfig.sound.defaultSound
  },

  isKnowledgeAiEnabled (state) {
    return Boolean(state?.widgetConfig?.knowledgeAI?.isEnabled)
   },
   
  knowledgeAiLaunchButtonData (state) {
    return state?.widgetConfig?.knowledgeAI?.launchButton
  },
  getAgentDeskIdleTimeout (state) {
    return state.widgetConfig?.endChat?.agentDeskIdleTimeout || constantStrings.DEFAUlT_IDLE_TIMEOUT
  },
  getBotIdleTimeout (state) {
    return state.widgetConfig?.endChat?.idleTimeout || constantStrings.DEFAUlT_IDLE_TIMEOUT
  },
  isDynamicSourcesDisabled (state) {
    return state.widgetConfig?.dynamicSource === false
  },
  dynamicChatWidgetWidth (state) {
    return state.widgetConfig?.chatWidget?.width
  },
  dynamicChatWidgetHeight (state) {
    return state.widgetConfig?.chatWidget?.height
  },
  showInfoSuggestionIcon (state) {
    return state.widgetConfig?.customerSuccess?.showInfo === true
  },
  isStreamingEnabled (state) {
   return state.widgetConfig?.streamOnChatWidget?.enabled || false
  },
  disableInputFieldWhileStreaming(state) {
    return state.widgetConfig.InputFieldWhileStreaming === 'disable'
  },
  disableInputFieldOnSendMessage(state) {
    return state.widgetConfig?.footer?.disableInputOnSend?.state === true
  },
  timeoutInputFieldOnSendMessage(state) {
    return state.widgetConfig?.footer?.disableInputOnSend?.reEnableTimeout || 30000
  },
  scrollElementBeyondPX(state) {
    return parseInt(state.widgetConfig?.scrollToBottom?.showLength) || 24
  },
  isFallbackMechanismEnabled (state) {
    return state.controlType === 'BOT' && state.widgetConfig?.fallback?.enabled
  },
  getFallbackMechanismDuration (state) {
    return parseInt(state.widgetConfig?.fallback?.duration) || 120
  },
  getFallbackMechanismMaxRetry (state) {
    return parseInt(state.widgetConfig?.fallback?.maxRetry) || 10
  },
  getFallbackMechanismMessage (state) {
    return state.widgetConfig?.fallback?.message || "The AI Agent response didn't come through."
  },
  getFallbackMechanismActionButtons (state) {
    return state.widgetConfig?.fallback?.fallbackActionButtons || []
  },
  getFallbackAgentDeskMessage (state) {
    return state.widgetConfig?.liveAgentDeskConfig?.customHandoffConfig?.unsuccessfulConnectionMessage || 'Unable to connect to an agent. Conversation returning to the AI Agent.'
  },
  hasChatsInitiated(state) {
    const chatPillsArr = [
      constantStrings.CHAT_ENDED,
      constantStrings.RESTART_CHAT_LABEL,
      constantStrings.SESSION_HAS_EXPIRED,
      constantStrings.CHAT_ENDED_WITH_TRANSCRIPT
    ]
    const chats = state.chats
    return (
      !chatPillsArr.includes(
        chats?.[(chats || []).length - 1]?.content?.message
      ) &&
      (chats || []).some(
        chat => !chatPillsArr.includes(chat?.content?.message)
      )
    )
  },
  isTypingIndicatorEnabled(state) {
    const typingIndicatorConfig = state?.widgetConfig?.typingIndicator
    if ('enabled' in typingIndicatorConfig) {
      return typingIndicatorConfig?.enabled
    }
    return true
  },
  isCSATValid(state) {
    return state.csat.isEnabled && state.widgetConfig.persistentSurveyConfig?.isPersistentSurveyEnabled
  },
  getCSATRating(state) {
    return state.csat.rating
  },
  isPromptTestingEnable(state) {
    return state.promptTestDetails?.active
  },
  isResponseAnalyzerEnabled(state) {
    return state.promptTestDetails?.isResponseAnalyzerWidget
  },
  isVoiceEnabled(state, getters) {
    return Boolean(state?.widgetConfig?.voiceConfig?.enabled) && !getters.isPromptTestingEnable
  },
  isDigitalVoiceCustomAttributeValid(state, getters) {
    return getters.isVoiceEnabled && state.widgetConfig?.voiceConfig?.digitalVoiceEvent !== false
  },
  restartButtonHoverText(state) {
    return state.widgetConfig?.restartChat?.hoverText 
  },
  retainQuickReplies(state) {
    return state.widgetConfig?.retainQuickReplies
  },
  textToSpeechOrationResponse(state) {
    return state.widgetConfig?.textToSpeechOrationResponse
  },
  isProgressiveTypingIndicatorEnabled(state) {
    return state.widgetConfig.progressiveTypingIndicator?.enabled || false
  },
  normalizationPhrases(state) {
    return state.widgetConfig?.voiceConfig?.normalizationPhrases || {}
  },
  speechToTextPhraseList(state) {
    return state.widgetConfig?.voiceConfig?.phraseList || []
  },
  voiceTTSProvider(state) { // google / 11labs
    return state.widgetConfig.voiceConfig?.voiceTTSProvider || 'google'
  },
  elevenLabsWebSocketEnabled(state) {
    return state.widgetConfig.voiceConfig?.elevenLabsWebSocketEnabled
  },
  enableBackendElevenLabsSocket(state) {
    return state.widgetConfig.voiceConfig?.enableBackendElevenLabsSocket
  },
  elevenLabsConnectionConfigs(state) {
    return state.widgetConfig.voiceConfig?.elevenLabsConnectionConfigs
  },
  getProgressiveTypingIndicatorConfig(state) {
    return state.progressiveTypingIndicatorConfig
  },
  typingIndicatorSoundConfig(state) {
    return state.widgetConfig?.typingIndicatorSound
  },
  isUserResponseBubbleMaxWidthEnabled(state) {
    return state.widgetConfig?.theme?.chatBubble?.setUserResponseWidthToMax || false
  },
  isBotResponseBubbleMaxWidthEnabled(state) {
    return state.widgetConfig?.theme?.chatBubble?.setBotResponseWidthToMax || false
  },
  scanFileForMalwareEnabled(state) {
    return state.widgetConfig?.scanFileForMalwareEnabled || false
  },
  getCustomFontFamily(state) {
    return state.widgetConfig?.font?.fontFamily?.value || 'Proxima Nova'
  },
  getUserDefinedFontFamily(state) {
    const value = state.widgetConfig?.font?.fontFamily?.value
    if (value === 'Custom') {
      return state.widgetConfig?.font?.fontFamily?.customFonts?.FileLink?.family || state.widgetConfig?.font?.fontFamily?.customFonts?.googleFont?.family
    }
    return value
  },
  isFontFamilyChatInterfaceOverrideEnabled(state) {
    return state.widgetConfig?.font?.fontFamily?.overrideChatInterfaceContent || false
  },
  isFontFamilyWFContentOverrideEnabled(state) {
    return state.widgetConfig?.font?.fontFamily?.overrideWorkflowContent || false
  },
  isFontSizeChatInterfaceOverrideEnabled(state) {
    return state.widgetConfig?.font?.fontSize?.overrideChatInterfaceContent || false
  },
  isFontSizeWFContentOverrideEnabled(state) {
    return state.widgetConfig?.font?.fontSize?.overrideWorkflowContent || false
  },
  getFontSizeType(state) {
    return state.widgetConfig?.font?.fontSize?.value || 'default'
  },
  getBrowserFontSizeSetting(state) {
    return state.browserFontSizeSetting
  },
  languageVoiceMap(state) {
    return state.widgetConfig?.voiceConfig?.languageVoiceMap || {}
  },
  autoDetectLanguages(state) {
    return state.widgetConfig?.voiceConfig?.azureAutoDetectLanguages || []
  },
  formEncryptionPublicKey(state) {
    return state.formEncryptionPublicKey || ''
  },
  proactiveTriggerType(state) {
    return state.widgetConfig?.proactiveTriggerType
  },
  botPCIPolicy(state) {
    return state.botPCIPolicy || {}
  },
  showAcceptance(state) {
    return state.widgetConfig?.showAcceptance || false
  },
  userTypingEvent(state) {
    return state.widgetConfig?.userTypingEvent || false
  },
  sendAttachmentQueryToDS(state) {
    return state.widgetConfig?.sendAttachmentQueryToDS || false
  }
}
